import { View, Text, StyleSheet } from 'react-native'
import { mesaColorNames, typography } from '@/src/common/theme'

export function Detail({
  category,
  description,
}: {
  category: string
  description?: string | null
}) {
  return (
    <View style={styles.detailsParagraph}>
      <Text style={styles.categoryText}>{category}</Text>
      <Text selectable style={[styles.detailsText, !description && { fontStyle: 'italic' }]}>
        {description || 'N/A'}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  detailsParagraph: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 48,
  },
  categoryText: StyleSheet.flatten([
    typography['paragraph/sm'],
    { color: mesaColorNames['global/grey/60 #6E7375'] },
  ]),
  detailsText: StyleSheet.flatten([
    typography['paragraph/sm'],
    {
      color: mesaColorNames['global/grey/80 #2F3133'],
      flexShrink: 1,
      flexGrow: 1,
      textAlign: 'right',
    },
  ]),
})
